import React, { useEffect, useState } from 'react';
import { Row, Col, Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { formFields, formFields1 } from './formField';
import { isEmpty, omit } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { FormField } from 'components';

const Terms = () => {
  const [form] = useForm();
  const user = useSelector(state => state.user);
  const appDetails = useSelector(state => state.appTrack.apptrackDetails);
  const localTaskVariables = appDetails?.localTaskVariables
  const apptrackDetails = isEmpty(localTaskVariables) || appDetails.activeTaskName !== 'task.name.submit_application' ? appDetails?.variablesIndexed : localTaskVariables;
  const carrier = useSelector(state => state.forms.carrier);
  const viewMode = true;


  useEffect(() => {
    form.setFieldsValue({
      terms0: apptrackDetails.terms0,
      terms1: apptrackDetails.terms1,
      terms2: apptrackDetails.terms2,
      terms3: apptrackDetails.terms3,
      terms4: apptrackDetails.terms4,
      terms5: apptrackDetails.terms5,
      terms6: apptrackDetails.terms6,
      terms7: apptrackDetails.terms7,
      terms8: apptrackDetails.terms8,
      terms9: apptrackDetails.terms9,
      terms10: apptrackDetails.terms10,
      terms11: apptrackDetails.terms11,
      terms12: apptrackDetails.terms12,
      terms13: apptrackDetails.terms13,

    });
  }, [form, apptrackDetails]);

  return (
    <div>
      <Form
        form={form}
        trigger="onChange"
      >
        <p className="mt-6 mr-0 color-blue-3 text-bold font-size-24">
          Όροι και Προϋποθέσεις
        </p>
         <p className='text-bold'>
                Η υποβολή της Αίτησης Συμμετοχής στο Πρόγραμμα επέχει τη θέση Υπεύθυνης Δήλωσης του Ν. 1599/1986.Ενεργώντας ως νόμιμος εκπρόσωπος της επιχείρησης για τους σκοπούς υποβολής της παρούσας αίτησης, δηλώνω υπεύθυνα ότι η επιχείρηση:        </p>
                <Row style={{ width: '93%' }}>
                  {formFields.map((field, index) => {
                    return (
                      <Col key={index} className="gutter-row" span={24}>
                        <Form.Item
                          name={[field.name]}
                          rules={field.rules}
                          valuePropName="checked"
                        >
                          <FormField
                            key={index}
                            disabled={viewMode}
                            style={
                              viewMode
                                ? { pointerEvents: 'none', cursor: 'not-allowed' }
                                : { }
                            }
                            className={viewMode ? 'custom-checkbox-disabled' : ''}
                            {...omit(field, ['span', 'rules'])}
                          />
                        </Form.Item>
                      </Col>
                    );
                  })}
                  <Col
                    key={1}
                    className="gutter-row"
                    span={'24'}
                    style={{ marginTop: '1rem' }}
                  >
                    <Form.Item
                      className="requirementsRadio"
                      name={'terms22'}
                      id={'terms22'}
                      rules={[
                        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
                      ]}
                    ></Form.Item>
                  </Col>
                </Row>
                <p className='text-bold'>
                Επίσης, ενεργώντας ως νόμιμος εκπρόσωπος της επιχείρησης για τους σκοπούς υποβολής της παρούσας αίτησης, δηλώνω υπεύθυνα ότι:</p>
                <Row style={{ width: '91%' }}>
                  {formFields1.map((field, index) => {
                    return (
                      <Col key={index} className="gutter-row" span={24}>
                        <Form.Item
                          name={[field.name]}
                          rules={field.rules}
                          valuePropName="checked"
                        >
                          <FormField
                            key={index}
                            disabled={viewMode}
                            style={
                              viewMode
                                ? { pointerEvents: 'none', cursor: 'not-allowed' }
                                : {}
                            }
                            className={viewMode ? 'custom-checkbox-disabled' : ''}
                            {...omit(field, ['span', 'rules'])}
                            
                          />
                        </Form.Item>
                      </Col>
                    );
                  })}
                  <Col
                    key={1}
                    className="gutter-row"
                    span={'24'}
                    style={{ marginTop: '1rem' }}
                  >
                    <Form.Item
                      className="requirementsRadio"
                      name={'terms22'}
                      id={'terms22'}
                      rules={[
                        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
                      ]}
                    ></Form.Item>
                  </Col>
                </Row>
      </Form>
    </div>
  );
};

export default Terms;
